import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";
import SystemUsageReportHomeSection from "../../components/Reports/SystemUsageReports/SystemUsageReportHomeSection";
import AssessmentReportSection from "../../components/Reports/assessmentReport/AssessmentReportSection";

export const AssessmentResponsReport = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <Loader start={isLoading} />
            <Page>
                <AssessmentReportSection
                    setIsLoading={setIsLoading} 
                    isLoading={isLoading}
                    isMobile={false}
                />
            </Page>
        </>
    )
}

export default AssessmentResponsReport;